import { useQuery } from "@tanstack/react-query";
import { getVacationDaysAvailable } from "../api/licenseApplicationApi";
import { licenseApplicationKeys } from "../api/licenseApplicationKeys";

export const useVacationDaysAvailable = () =>
  useQuery({
    queryKey: licenseApplicationKeys.vacationDays(),
    queryFn: getVacationDaysAvailable,
  });
